var React = require('react');

function InfoCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 1c3.859 0 7 3.141 7 7 0 3.861-3.141 7-7 7s-7-3.139-7-7c0-3.859 3.141-7 7-7zm-.25 4.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm1.785 6.019h-.542c.004-1.328.003-4.146-.003-4.633-.003-.251-.115-.374-.32-.37-.189.006-.376.003-.565.002H7.302 6.5a.5.5 0 1 0 0 1h.497a889.327 889.327 0 0 0 0 4H6.5a.5.5 0 1 0 0 1h3.035a.5.5 0 0 0 0-1z"}));
}

InfoCircle.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = InfoCircle;

InfoCircle.default = InfoCircle;
